// global axios
attachEvent('.product-card-list__open-filters', 'click', (ev) => {
  ev.target.closest('.product-card-list').querySelector('.product-card-list__others').classList.add('is-open');
  toggleBodyScrollLock(true);
});

attachEvent('.product-card-list__others-close', 'click', (ev) => {
  ev.target.closest('.product-card-list__others').classList.remove('is-open');
  toggleBodyScrollLock(false);
});

// Filter and Pagination via ajax & DataLayer GTAG New
const productListSelector =
  '.product-card-list__cards, .search-results__items.products, .product-detail__extra-items, .sc-product-slider .swiper-wrapper';

const cardList = document.querySelector(productListSelector);

if (cardList) {
  const viewItemListBatchSize = 15;
  const { body } = document;
  const trackerState = new Map();

  const getProductListContainers = () => Array.from(document.querySelectorAll(productListSelector));

  const getProductCards = (container) => Array.from(container?.querySelectorAll('.product-card') || []);

  const getTracker = (container) => {
    if (!trackerState.has(container)) {
      trackerState.set(container, {
        observer: null,
        firstSegmentTimeoutId: null,
        observedProductKeys: new Set(),
        pendingProducts: [],
      });
    }
    return trackerState.get(container);
  };

  const getListContext = (container) => {
    if (body.classList.contains('search-page') || container?.classList.contains('search-results__items')) {
      return {
        item_list_id: 'search_products',
        item_list_name: 'Search products',
      };
    }
    if (body.classList.contains('product-single')) {
      return {
        item_list_id: 'recommended_products',
        item_list_name: 'Recommended products',
      };
    }
    if (body.classList.contains('post-single')) {
      return {
        item_list_id: 'article_recommended_products',
        item_list_name: 'Article recommended products',
      };
    }
    if (container?.closest('.sc-product-card-list')?.dataset?.brand) {
      return {
        item_list_id: 'brand_products',
        item_list_name: 'Brand products',
      };
    }
    if (container?.closest('.sc-product-slider')?.dataset?.brand) {
      return {
        item_list_id: 'brand_products',
        item_list_name: 'Brand products',
      };
    }
    return {
      item_list_id: 'collection_products',
      item_list_name: 'Collection products',
    };
  };

  const resetTrackingState = (tracker) => {
    if (tracker.firstSegmentTimeoutId) {
      clearTimeout(tracker.firstSegmentTimeoutId);
      tracker.firstSegmentTimeoutId = null;
    }

    tracker.observedProductKeys = new Set();
    tracker.pendingProducts = [];
  };

  const sendToGA4 = (items) => {
    if (!items.length) {
      return;
    }

    const orderedItems = [...items].sort((a, b) => a.index - b.index);

    const { item_list_id: itemListId, item_list_name: itemListName } = orderedItems[0];

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'view_item_list',
      ecommerce: {
        site_type: 'catalog',
        item_list_id: itemListId,
        item_list_name: itemListName,
        items: orderedItems,
      },
    });
  };

  const parseProductCard = (productCard, container) => {
    const anchor = productCard.querySelector('.product-card__link');

    if (!anchor?.dataset.productItem) {
      return null;
    }

    let productItem = null;

    try {
      productItem = JSON.parse(anchor.dataset.productItem);
    } catch (error) {
      console.error(error);
      return null;
    }

    const index = Number(anchor.dataset.productIndex);
    if (!productItem?.item_id || !Number.isFinite(index)) {
      return null;
    }

    const listContext = getListContext(container);

    return {
      ...productItem,
      ...listContext,
      index,
    };
  };

  const getObservedKey = (productItem) => `${productItem.item_id}::${productItem.index}`;

  const markProductsAsObserved = (tracker, items) => {
    items.forEach((item) => {
      tracker.observedProductKeys.add(getObservedKey(item));
    });
  };

  const hasObservedSegment = (tracker, items) =>
    items.every((item) => tracker.observedProductKeys.has(getObservedKey(item)));

  const getTrackableCards = (container) =>
    getProductCards(container)
      .map((productCard) => ({
        productCard,
        productItem: parseProductCard(productCard, container),
      }))
      .filter(({ productItem }) => !!productItem);

  const getProductSegments = (container) => {
    const trackableCards = getTrackableCards(container);

    return trackableCards.reduce((segments, item, index) => {
      const segmentIndex = Math.floor(index / viewItemListBatchSize);

      if (!segments[segmentIndex]) {
        segments[segmentIndex] = [];
      }

      segments[segmentIndex].push(item);
      return segments;
    }, []);
  };

  const shouldWaitForFirstSegmentViewport = (container) =>
    container?.matches('.sc-product-slider .swiper-wrapper, .product-detail__extra-items');

  const sendSegmentToGA4 = (tracker, segment) => {
    const segmentItems = segment.map(({ productItem }) => productItem);

    if (!segmentItems.length || hasObservedSegment(tracker, segmentItems)) {
      return;
    }

    markProductsAsObserved(tracker, segmentItems);
    sendToGA4(segmentItems);
  };

  const queueFirstSegment = (tracker, segment, delay = 0) => {
    if (tracker.firstSegmentTimeoutId) {
      clearTimeout(tracker.firstSegmentTimeoutId);
      tracker.firstSegmentTimeoutId = null;
    }

    const sendFirstSegment = () => {
      tracker.firstSegmentTimeoutId = null;
      sendSegmentToGA4(tracker, segment);
    };

    if (delay > 0) {
      tracker.firstSegmentTimeoutId = window.setTimeout(sendFirstSegment, delay);
      return;
    }

    sendFirstSegment();
  };

  const observeVisibleProducts = (container, { reset = false, firstSegmentDelay = 0 } = {}) => {
    const segments = getProductSegments(container);
    const tracker = getTracker(container);

    if (tracker.observer) {
      tracker.observer.disconnect();
    }

    if (tracker.firstSegmentTimeoutId) {
      clearTimeout(tracker.firstSegmentTimeoutId);
      tracker.firstSegmentTimeoutId = null;
    }

    if (reset) {
      resetTrackingState(tracker);
    }

    if (!segments.length) {
      return;
    }

    const firstSegmentIndexToObserve = shouldWaitForFirstSegmentViewport(container) ? 0 : 1;

    if (!shouldWaitForFirstSegmentViewport(container)) {
      queueFirstSegment(tracker, segments[0], firstSegmentDelay);
    }

    const segmentTriggers = new Map();

    tracker.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          const segment = segmentTriggers.get(entry.target);
          if (!segment) {
            return;
          }

          sendSegmentToGA4(tracker, segment);

          tracker.observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: 0,
      },
    );

    segments.slice(firstSegmentIndexToObserve).forEach((segment) => {
      const firstSegmentCard = segment[0]?.productCard;

      if (!firstSegmentCard) {
        return;
      }

      segmentTriggers.set(firstSegmentCard, segment);
      tracker.observer.observe(firstSegmentCard);
    });
  };

  const observeAllVisibleProducts = () => {
    getProductListContainers().forEach((container) => {
      observeVisibleProducts(container, { reset: !trackerState.has(container) });
    });
  };

  const axiosGetCardList = async (parent, pageNumber) => {
    const amount = document.querySelector('input[name="amount"]:checked')?.value || '';
    const sort = document.querySelector('input[name="sort"]:checked')?.value || '';

    let [baseUrl] = window.location.href.split('?');
    baseUrl = `${baseUrl}?`;
    const action = 'getMoreProducts';
    const { category } = document.querySelector('.page-template').dataset || '';
    const brand = document.querySelector('.sc-product-card-list')?.dataset.brand || '';
    const listInner = document.querySelector('.product-card-list__cards, .search-results__items');

    const search = cardList.dataset.term || '';

    const formDataInput = {
      action,
      pageNumber,
      category,
      sort,
      amount,
      brand,
      search,
    };

    try {
      const { data } = await axios.post(localData.apiURL, formDataInput);
      listInner.innerHTML = '';

      if (listInner && data.data.html_list) {
        listInner.innerHTML = data.data.html_list;
        setTimeout(() => {
          observeVisibleProducts(listInner, { reset: true, firstSegmentDelay: 1000 });
        }, 1000);
      }

      const productNumber = parent?.querySelector('.product-card-list__nr');
      if (productNumber) {
        productNumber.innerHTML = data.data.show_text;
      }

      const paginationButton = parent?.querySelector('.product-card-list__pagination button.btn');
      if (paginationButton) {
        paginationButton.classList.toggle('is-disabled', data.data.is_last);
      }

      const pagination = parent?.querySelector('.pagination');
      if (pagination) {
        pagination.innerHTML = data.data.pagination;
      }

      const urlParams = ['pageNumber', 'sort', 'amount']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');
      window.history.pushState({}, '', baseUrl + (urlParams ? `${urlParams}` : ''));
      document.querySelector('.page-template').scrollIntoView({ behavior: 'smooth' });
      paginationButton?.blur();
    } catch (err) {
      console.error(err);
    }
  };

  // Pagination
  attachEvent('.sc-product-card-list .pagination .page-numbers', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.sc-product-card-list');

    const pageNumber = ev.target.closest('a').dataset.number;
    if (pageNumber !== 'disabled') {
      axiosGetCardList(parent, pageNumber);
    }
  });
  attachEvent('.product-card-list__pagination button.btn', 'click', (ev) => {
    ev.preventDefault();
    if (document.querySelector('.pagination .next')) {
      document.querySelector('.pagination .next').click();
    }
  });
  attachEvent('input[name="amount"], input[name="sort"]', 'click', (ev) => {
    const parent = ev.target.closest('.sc-product-card-list');
    axiosGetCardList(parent, 1);
  });
  attachEvent('.product-card-list__read-more', 'click', (ev) => {
    ev.preventDefault();
    const editorText = document.querySelector('.product-card-list__text-more .editor-text');
    if (editorText) {
      editorText.scrollIntoView({ behavior: 'smooth' });
    }
  });
  observeAllVisibleProducts();
}
